import { TreeCommandCardProps } from 'business/models/CustomModels';
import React from 'react';
import './card.scss';
import { IStyle } from 'Styles';

const TreeCommandCard = ({
  iconName,
  title,
  loadImageIcon,
  onClick,
  children,
  active,
  customStyle,
  customTextStyle,
}: TreeCommandCardProps) => {
  return (
    <li
      id="tree-command-card-pointer"
      data-testid="tree-command-card-pointer"
      className={
        active
          ? 'list-item-node node treeCommand cursor-pointer active-scores-card'
          : 'list-item-node node treeCommand cursor-pointer'
      }
      style={customStyle}
      tabIndex={1}
    >
      <div
        id="tree-command-content-node"
        data-testid="tree-command-content-node"
        className="list-content-node flex-column flex-y-center"
        data-align="center"
        onClick={onClick}
      >
        {loadImageIcon && (
          <div id="tools-command-card-icon" style={styles.iconContainer}>
            <img
              id="tree-command-card-img-icon"
              data-testid="tree-command-card-img-icon"
              alt="Not Found"
              style={styles.image}
              src={loadImageIcon(iconName)}
            />
          </div>
        )}
        {children}
        {}
        <div
          id={`tree-command-content-noselectnode-${title}`}
          data-testid={`tree-command-content-noselectnode-${title}`}
          className="noSelectNode"
          style={customTextStyle}
        >
          {title}
        </div>
      </div>
    </li>
  );
};

const styles: IStyle = {
  iconContainer: {
    minWidth: '100%',
    textAlignLast: 'center',
  },
  image: {
    marginTop: '20%',
    width: '20%',
  },
};

export default TreeCommandCard;
